module.exports = __webpack_public_path__ + "img/文本图 视频_1.60f9637e.jpg";